// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gcQR","newExpiryDate":"styles_newExpiryDate__1Exsv","footer":"styles_footer__3ufWw"};